export function CodeSuggestionUnavailable({reason, className = 'm-2'}: {reason: string; className?: string}) {
  return (
    <div className={className}>
      <small className="fgColor-muted">{reason}</small>
    </div>
  )
}

try{ CodeSuggestionUnavailable.displayName ||= 'CodeSuggestionUnavailable' } catch {}